import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const LeadMenuIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <path
                d="M14.1 19.9992H0V18.0992C0 16.9992 0.7 15.9992 1.7 15.5992L4.7 14.4992V13.1992H5.9V15.3992L2.1 16.7992C1.6 16.8992 1.2 17.4992 1.2 18.0992V18.7992H12.9V18.0992C12.9 17.4992 12.5 16.9992 12 16.7992L8.2 15.3992V13.1992H9.4V14.4992L12.4 15.5992C13.4 15.9992 14.1 16.9992 14.1 18.0992V19.9992V19.9992Z"
                fill="#21006E"
            />
            <path
                d="M7 14.4C4.8 14.4 3 12.3 3 9.7C3 7.1 4.8 5 7 5C9.2 5 11 7.1 11 9.7C11 12.3 9.2 14.4 7 14.4ZM7 6.2C5.5 6.2 4.2 7.8 4.2 9.7C4.2 11.6 5.4 13.2 7 13.2C8.5 13.2 9.8 11.6 9.8 9.7C9.8 7.8 8.6 6.2 7 6.2Z"
                fill="#21006E"
            />
            <path
                d="M23.1002 19.9992H13.7002L13.7004 17.0043L11.5 16.4992L10.5 15.5992L13.7002 14.4992V13.1992H14.9002V15.3992L11.5 16.4992L13.7004 17.0043L13.7003 18.7992H14.9002H21.9002V18.0992C21.9002 17.4992 21.5002 16.9992 21.0002 16.7992L17.2002 15.3992V13.1992H18.4002V14.4992L21.4002 15.5992C22.4002 15.9992 23.1002 16.9992 23.1002 18.0992V19.9992Z"
                fill="#21006E"
            />
            <path
                d="M16 14.4C13.8 14.4 12 12.3 12 9.7C12 7.1 13.8 5 16 5C18.2 5 20 7.1 20 9.7C20 12.3 18.2 14.4 16 14.4ZM16 6.2C14.5 6.2 13.2 7.8 13.2 9.7C13.2 11.6 14.4 13.2 16 13.2C17.5 13.2 18.8 11.6 18.8 9.7C18.8 7.8 17.6 6.2 16 6.2Z"
                fill="#21006E"
            />
        </SvgIcon>
    );
};
